import FeatSDKV1 from 'api/version1';
import { createEffect } from 'effector';

export const getLegalsDocumentsFx = createEffect(
  FeatSDKV1.legals.getLegalsDocuments,
);
